import { useState } from "react";
import { OdsPriorityGroupsWithGrouped } from "../../../interfaces/ODSPriorityGroups";
import EmptyState from "../../Cards/EmptyState";
import EvaluationTypeIndicator from "../../Cards/EvaluationTypeIndicator";
import Tables from "./Tables";
import { MdAdsClick } from "react-icons/md";
import HintPopover from "../../Popover/HintPopover";

const PriorityGroupsIndicatorsView = ({
    data,
    selectedTypeIndicator,
    handleSelectTypeIndicator,
    pagination,
    period,
    handlePageChange,
    module
}: {
    data: OdsPriorityGroupsWithGrouped & { type: 'grupos-prioritarios' };
    selectedTypeIndicator: string | null;
    handleSelectTypeIndicator: (type: string) => void;
    pagination: { currentPage: number; pageSize: number };
    period: string;
    handlePageChange: (page: number) => void;
    module: string;
}) => {
    const entries = Object.entries(data.tipo_indicador);
    const [showHint, setShowHint] = useState(true);

    const handleSelect = (tipo: string) => {
        setShowHint(false);
        handleSelectTypeIndicator(tipo);
    };

    return (
        <div className="mt-10" id='type_indicator_groups'>
            <div className="relative flex flex-col md:flex-row w-full justify-between gap-3">
                {showHint && !selectedTypeIndicator && (
                    <HintPopover
                        message="Seleccioná un tipo de indicador para visualizar la información disponible"
                        icon={<MdAdsClick size={24} className="text-brand-green-30 shrink-0" />}
                        onClose={() => setShowHint(false)}
                    />
                )}
                <div className="flex gap-2 lg:gap-3 w-full">
                    {entries.map(([tipo]) => (
                        <div key={tipo} className="flex-1">
                            <EvaluationTypeIndicator
                                label={tipo}
                                status={1}
                                size={12}
                                isSelected={selectedTypeIndicator === tipo}
                                handleClick={() => handleSelect(tipo)}
                                showStatus={false}
                                numberOfIndicators={data.tipo_indicador[tipo]?.length}
                            />
                        </div>
                    ))}
                </div>
            </div>
            {selectedTypeIndicator ? (
                data.tipo_indicador[selectedTypeIndicator]?.length ? (
                    <div className="mt-8">
                        <Tables
                            indicadores={data.tipo_indicador[selectedTypeIndicator]}
                            period={period}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                            odsSelected={data}
                            module={module}
                        />
                    </div>
                ) : (
                    <div className="mt-8">
                        <EmptyState message="Hasta el momento no existen indicadores a mostrar" />
                    </div>
                )
            ) : null}

        </div>
    );
};

export default PriorityGroupsIndicatorsView